import { Tag, TreeNodeProps } from "antd";
import { ReactNode, useState } from "react";
import { GLOB } from "src/util/Glob";

interface Props {
  items: TagItem[];
  onClose: (id: string) => (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

export type TreeItem = Pick<TreeNodeProps, "title" | "key">;
export type TagItem = TreeItem & { disabled?: boolean, deleted?: boolean; };

function TagsList({ items, onClose }: Props) {
  const [tagItems, setTagItems] = useState<TagItem[]>([]);
  const [prevItems, setPrevItems] = useState<TagItem[]>([]);

  if (items !== prevItems) {
    setPrevItems(items);
    setTagItems(prev => {
      const tags: TagItem[] = items?.length ? [...items] : [];

      tags.forEach(item => {
        for (const tag of prev) {
          if (item.key === tag.key) {
            if (!item.title)
              item.title = tag.title;
            break;
          }
        }
      });

      return tags.sort((a, b) => GLOB.naturalSort(a.title, b.title));
    });
  }

  const handleClose = (key: string) => (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setTagItems(prev => prev.filter(item => key !== item.key));
    onClose(key)(e);
  };

  // show tooltip with the full label only when it's truncated
  const showTitleIfTruncated = (e: React.MouseEvent<HTMLElement>) => {
    const el = e.currentTarget;
    el.title = el.scrollWidth > el.clientWidth ? el.textContent ?? '' : '';
  };

  const { readonly } = GLOB.userInfo;
  return (
    <div className="xm-tags-container">
      {tagItems.map(({ title, key, disabled, deleted }) => {
        let className = 'xm-item-tag';

        if (disabled)
          className += ' disabled';

        return <Tag closable={!readonly} className={className} key={key} onClose={handleClose(key as string)}>
          <span className={deleted ? 'xm-tag-content deleted' : 'xm-tag-content'}>
            <span className="xm-tag-label" onMouseEnter={showTitleIfTruncated}>{title as ReactNode}</span>
          </span>
        </Tag>;
      })}
    </div>
  );
}


export default TagsList;